import React from 'react';
import style from './SingleCombo.module.scss';
import { StarFilled, PlusCircleOutlined } from '@ant-design/icons';
import { CustomButton } from '../../../utils/Utils';

const SingleCombo = ({combo}) => { // eslint-disable-line
  const { singleComboContainer, title, cardContainer, starIcon, articles, detailBtn, addBtn, plusIcon } = style;

  
  return (
    <div className={singleComboContainer}>
      <div className={cardContainer}>
        <StarFilled className={starIcon}/>
        <h1 className={title}>Title </h1>
        <p className={articles}>(55 artículos)</p>
        <CustomButton className={detailBtn} color='btnOutline' content='VER DETALLE' />
        <CustomButton className={addBtn} color='btnPrimary' content={<><span>AÑADIR</span><PlusCircleOutlined className={plusIcon} /></>} />
      </div>
    </div>
  );
};

export default SingleCombo;
